export default "__VITE_ASSET__DU3d28ZK__"